import { useContext } from 'react'
import { NavigationContext } from '@/contexts/navigationContext'

const useNavigation = () => {
    const context = useContext(NavigationContext)

    if (!context)
        throw new Error('useNavigation must be used within a NavigationProvider')

    return context
};

export { useNavigation }
